module.exports = __webpack_public_path__ + "img/product_25.fbee4f5.jpg";